import Vue from 'vue'
Vue.directive('showTips',{
  inserted(el) {
  },
  bind : function (el, binding, vnode) {
    el.addEventListener('click', function (e) {
      setTimeout(()=>{
        if(el.scrollHeight>el.clientHeight+2){
          // 创建浮层元素并设置样式
          const vcTooltipDom = document.createElement('div')
          // 设置id方便寻找
          vcTooltipDom.setAttribute('id', 'vc-tooltip')
          // 将浮层插入到body中
          document.body.appendChild(vcTooltipDom)
          // el.parentNode.appendChild(vcTooltipDom)
          // console.log('vcTooltipDom===',vcTooltipDom);
          // 浮层中的文字
          document.getElementById('vc-tooltip').innerHTML = el.innerText
          // console.log('高=====',vcTooltipDom.scrollHeight);
          vcTooltipDom.style.cssText = `
            max-width:800px;
            min-width:150px;
            overflow: auto;
            position: fixed;
            top:${e.clientY+20}px;
            left:${e.clientX - e.offsetX}px;
            background: rgba(0, 0 , 0, .8);
            color:#fff;
            border-radius:5px;
            padding:10px;
            line-height:20px;
            display:inline-block;
            font-size:12px;
            z-index:97
          `
        }
      },100)
      // if(el.scrollHeight>41){


    })

  },

})
window.addEventListener("scroll", function () {
  const vcTooltipDom = document.getElementById('vc-tooltip')
  vcTooltipDom && document.body.removeChild(vcTooltipDom)
})
document.onclick = function (e) {
  if (document.getElementById("vc-tooltip")) {
    const vcTooltipDom = document.getElementById("vc-tooltip");
    vcTooltipDom && document.body.removeChild(vcTooltipDom);
  }
};



// WEBPACK FOOTER //
// ./src/directive/showTips.js